
export class ClrResponsiveNavControlMessage {
/**
 * @param {?} _controlCode
 * @param {?} _navLevel
 */
constructor(private _controlCode: string,
private _navLevel: number) {}
/**
 * @return {?}
 */
get controlCode(): string {
        return this._controlCode;
    }
/**
 * @return {?}
 */
get navLevel(): number {
        return this._navLevel;
    }
}

function ClrResponsiveNavControlMessage_tsickle_Closure_declarations() {
/** @type {?} */
ClrResponsiveNavControlMessage.prototype._controlCode;
/** @type {?} */
ClrResponsiveNavControlMessage.prototype._navLevel;
}

